import { State } from '@/components/atoms';
import { ProductCard, TabsContent } from '@/components/molecules';
import { useProducts, useDeleteProduct, useUpdateProduct } from '@/api';
import { filterProducts } from '@/lib/helpers/filter-products';

interface InStoreProductsProps {
  onAddProduct: () => void;
  searchQuery: string;
  categoryId?: number;
  subcategoryId?: number;
  onView: (id: number) => void;
  onEdit: (id: number) => void;
}

export const InStoreProducts = ({
  onAddProduct,
  searchQuery,
  categoryId,
  subcategoryId,
  onView,
  onEdit,
}: InStoreProductsProps) => {
  const { data: products } = useProducts({ categoryId, subcategoryId });
  const { mutate: remove } = useDeleteProduct();
  const { mutate: update } = useUpdateProduct();

  const inStoreProducts = filterProducts(
    products?.filter((product) => product.quantity > 0),
    { searchQuery, categoryId, subcategoryId }
  );

  const hasActiveFilters =
    !!searchQuery.trim() || categoryId != null || subcategoryId != null;

  return (
    <TabsContent value="in-store">
      {!inStoreProducts || inStoreProducts.length < 1 ? (
        <State
          description={
            hasActiveFilters
              ? 'No in-store products match your filters'
              : "You don't have any products in store"
          }
          button={
            hasActiveFilters
              ? undefined
              : {
                  icon: 'Plus',
                  text: 'Add Product',
                  onClick: onAddProduct,
                }
          }
        />
      ) : (
        <div className="grid grid-cols-12 gap-2.5">
          {inStoreProducts.map((product, index) => (
            <ProductCard
              key={product?.id || index}
              id={product?.id}
              name={product?.name}
              description={product?.shortDescription}
              price={product?.price}
              categoryName={product?.category?.name}
              subcategoryName={product?.subcategory?.name}
              quantity={product?.quantity}
              images={product?.productImages?.map((img) => img?.image?.url)}
              handleDelete={() => remove(product?.id)}
              handleOOS={() => update({ quantity: 0, id: product?.id })}
              handleView={() => onView(product.id)}
              handleEdit={() => onEdit(product.id)}
              className="col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3"
              variant="owner"
            />
          ))}
        </div>
      )}
    </TabsContent>
  );
};
